export default [
    {
        title: '活动管理',
        path: '/activity',
        name: 'activityManagement',
        meta: {
            key: 'activity',
            open: 'activity'
        },
        permission: 'activity',
        menu: true,
        component: () => import('@/views/activity/list')
    },
    {
        title: '活动表单',
        path: '/activity/form',
        name: 'activityForm',
        meta: {
            key: 'activity',
            open: 'activity'
        },
        permission: false,
        menu: false,
        component: () => import('@/views/activity/form')
    },
    {
        title: '活动人员管理',
        path: '/activity/registration',
        name: 'activityRegistration',
        meta: {
            key: 'activity',
            open: 'activity'
        },
        permission: false,
        menu: false,
        component: () => import('@/views/activity/registration')
    }
];
